import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { getAuthService } from '../services/auth.service';
import { isStorkPlatform } from '../utils/utils';

export function useGetUserInfo(version = 1, options?: Partial<UseQueryOptions<IAuthMeV2OutputDto>>) {
    return useQuery({
        queryFn: async () => {
            const service = getAuthService();
            if (isStorkPlatform() || version === 2) {
                return service.getUserInfo();
            }
            try {
                return await service.getLegacyUserInfo();
            } catch {
                return await service.getUserInfo();
            }
        },
        queryKey: ['userInfo'],
        ...options,
    });
}

export default useGetUserInfo;
